import { gql } from '@apollo/client';

export default gql`
  fragment MediaSession on MediaSession {
    _id
    progress: maxProgress
    skipped: skipProgress
  }
`;
